var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.66667C2 4.69421 2.38631 3.76158 3.07394 3.07394C3.76158 2.38631 4.69421 2 5.66667 2H31.3333C32.3058 2 33.2384 2.38631 33.9261 3.07394C34.6137 3.76158 35 4.69421 35 5.66667V24C35 24.9725 34.6137 25.9051 33.9261 26.5927C33.2384 27.2804 32.3058 27.6667 31.3333 27.6667H5.66667C4.69421 27.6667 3.76158 27.2804 3.07394 26.5927C2.38631 25.9051 2 24.9725 2 24V5.66667Z",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.8335L18.5 16.8335L35 5.8335",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin1);
export default __webpack_public_path__ + "static/media/linkedin-1.be3010ba110ac99067717fcf4d5a985e.svg";
export { ForwardRef as ReactComponent };